<template>
  <v-input :rules="rules" :error.sync="error">
    <v-layout row>
      <v-flex xs4>
        <v-autocomplete
          :readonly="readonly"
          :error="error"
          v-model="dia"
          @change="cambiada"
          type="number"
          :items="dias"
          class="campo"
          placeholder="DD"
          hide-details="auto"
          auto-select-first
        ></v-autocomplete>
      </v-flex>
      <v-flex xs4>
        <v-autocomplete
          :readonly="readonly"
          :error="error"
          v-model="mes"
          @change="cambiada"
          :items="meses"
          type="number"
          class="campo"
          hide-details="auto"
          placeholder="MM"
          auto-select-first
        ></v-autocomplete>
      </v-flex>
      <v-flex xs4>
        <v-autocomplete
          :error="error"
          v-model="anio"
          @change="cambiada"
          class="campo"
          type="number"
          :readonly="readonly"
          placeholder="AAAA"
          hide-details="auto"
          :items="anios"
          auto-select-first
        ></v-autocomplete>
      </v-flex>
    </v-layout>
  </v-input>
</template>

<script>
export default {
  name: "datepicker",
  props: [
    "readonly",
    "value",
    "label",
    "rules",
    "max",
    "min",
    "outlined",
    "editando",
  ],
  data() {
    return {
      fecha: {},
      dia: null,
      mes: null,
      anio: null,
      error: null,
    };
  },
  mounted() {},
  created() {
    this.fecha = this.value;
  },
  watch: {
    fecha() {
      this.$emit("input", this.fecha);
      this.change();
    },
    value() {
      this.fecha = this.value;
      if (this.value) {
        const parts = this.value.split("-");
        this.dia = this.dias.find((d) => d === parts[2]);
        this.mes = this.meses.find((m) => m === parts[1]);
        this.anio = this.anios.find((a) => a === parts[0]);
      }
    },
  },
  methods: {
    change() {
      this.$emit("change");
    },
    cambiada(val) {
      this.$nextTick(() => {
        if (this.dias.indexOf(this.dia) === -1) {
          this.dia = null;
        }
        if (this.meses.indexOf(this.mes) === -1) {
          this.mes = null;
        }
        if (this.anios.indexOf(this.anio) === -1) {
          this.anio = null;
        }
        if (
          this.dia &&
          this.mes &&
          this.anio &&
          !isNaN(this.dia) &&
          !isNaN(this.mes) &&
          !isNaN(this.anio)
        ) {
          const fecha = new Date(
            parseInt(this.anio),
            parseInt(this.mes) - 1,
            parseInt(this.dia),
            1,
            0,
            0,
            0
          );
          if (
            !!this.fechaMinima &&
            fecha < this.fechaMinima &&
            !this.editando
          ) {
            this.fecha = "";
            return;
          }
          if (
            !!this.fechaMaxima &&
            fecha > this.fechaMaxima &&
            !this.editando
          ) {
            this.fecha = "";
            return;
          }
          this.fecha = this.fechaPicker(fecha);
        } else {
          this.fecha = "";
        }
      });
    },
    esBisiesto(year) {
      return year % 400 === 0
        ? true
        : year % 100 === 0
        ? false
        : year % 4 === 0;
    },
  },
  computed: {
    dias() {
      const dias = [];
      let max = 31;
      let min = 1;
      if (this.mes) {
        if ([4, 6, 9, 11].indexOf(parseInt(this.mes)) != -1) {
          max = 30;
        } else if ([1, 3, 5, 7, 8, 10, 12].indexOf(parseInt(this.mes)) != -1) {
          max = 31;
        } else if (parseInt(this.mes) === 2) {
          if (this.anio && this.esBisiesto(this.anio)) {
            max = 29;
          } else {
            max = 28;
          }
        }
      }
      if (this.fechaMaxima && !this.readonly && !this.editando) {
        const dmax = this.fechaMaxima;
        if (this.mes && parseInt(this.mes) === dmax.getMonth() + 1) {
          max = dmax.getDate();
        }
      }
      if (this.fechaMinima && !this.readonly && !this.editando) {
        const dmin = this.fechaMinima;
        if (this.mes && parseInt(this.mes) === dmin.getMonth() + 1) {
          min = dmin.getDate();
        }
      }
      for (var i = min; i <= max; i++) {
        dias.push(i < 10 ? "0" + String(i) : String(i));
      }
      return dias;
    },
    meses() {
      let max = 12;
      let min = 1;

      if (this.fechaMaxima && !this.readonly && !this.editando) {
        const dmax = this.fechaMaxima;
        if (this.anio && parseInt(this.anio) === dmax.getFullYear()) {
          max = dmax.getMonth() + 1;
        }
      }
      if (this.fechaMinima && !this.readonly && !this.editando) {
        const dmin = this.fechaMinima;
        if (this.anio && parseInt(this.anio) === dmin.getFullYear()) {
          min = dmin.getMonth() + 1;
        }
      }
      const res = [];
      for (var i = min; i <= max; i++) {
        res.push(i < 10 ? "0" + String(i) : String(i));
      }
      return res;
    },
    anios() {
      let date = new Date();
      date.setMonth(date.getMonth() + 2);
      let max = date.getFullYear() + 1;
      let min = 1900;
      if (this.fechaMaxima && !this.readonly && !this.editando) {
        max = this.fechaMaxima.getFullYear();
      }
      if (this.fechaMinima && !this.readonly && !this.editando) {
        min = this.fechaMinima.getFullYear();
      }
      const res = [];
      for (var i = max; i >= min; i--) {
        res.push(i < 10 ? "0" + String(i) : String(i));
      }
      return res;
    },
    fechaMinima() {
      if (!this.min) return null;
      const min = new Date(this.min);
      min.setHours(0, 0, 0);
      return min;
    },
    fechaMaxima() {
      if (!this.max) return null;
      const max = new Date(this.max);
      max.setHours(0, 0, 0);
      return max;
    },
  },
};
</script>

<style scoped>
.campo {
  width: 150px;
}
.contenedor {
  display: flex;
}
</style>
